module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }